import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import BigNumber from 'bignumber.js';

interface GetPnlProps {
  isLong: boolean;
  entryPrice: BigNumber;
  /**
   * market price for market close
   * FIXME: should it consider slippage?
   */
  closePrice: BigNumber;
  size: Position['size'];
  spreadPercentage: number;
}

/**
 * closePrice = marketPrice
 * closeNotionalUsd = closePrice * size
 * entryNotionalUsd = entryPrice * size
 * longPnl = (closeNotionalUsd - entryNotionalUsd)
 * shortPnl = (entryNotionalUsd - closeNotionalUsd)
 *
 * the pnl only consider the position size difference between entry and close, no fee is deducted
 *
 * when we are talking position, the spread already impacted on entryPrice, so we only need to include the close price 's spread calculation
 */
export const getPositionPnl = ({
  isLong,
  entryPrice,
  closePrice,
  size,
  spreadPercentage,
}: GetPnlProps): BigNumber => {
  const closePriceWithSpread = isLong
    ? closePrice.multipliedBy(1 - spreadPercentage) // for long, close price with spread is lower
    : closePrice.multipliedBy(1 + spreadPercentage); // for short, close price with spread is higher

  const closeNotionalUsd = closePriceWithSpread.multipliedBy(size);
  const entryNotionalUsd = entryPrice.multipliedBy(size);

  const rawPnl = isLong
    ? closeNotionalUsd.minus(entryNotionalUsd)
    : entryNotionalUsd.minus(closeNotionalUsd);

  return rawPnl;
};
